import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FilterOperator } from '../../types/filter-operators';

@Component({
  selector: 'soft-filter-operator',
  imports: [],
  templateUrl: './filter-operator.component.html',
  styleUrl: './filter-operator.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterOperatorComponent {
  operator = input.required<FilterOperator>();
}
